import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'sm-images-editor',
	template: require('./sm-images-editor.component.html')
})
export class SmImagesEditorComponent {
	@Input() images: ImageModel[] = [];
	@Input() max: number = 0;
	@Input() maxFileSize: number;
	@Output() onBegin: EventEmitter<any> = new EventEmitter();
	@Output() onChange: EventEmitter<ImageModel[]> = new EventEmitter();
	@Output() onRemove: EventEmitter<ImageModel> = new EventEmitter();
	@Output() onWhenAddingFileFailed: EventEmitter<any> = new EventEmitter();

	get canAdd() {
		return !this.max || this.max > this.images.length;
	}

	get maxFiles() {
		return this.max - this.images.length;
	}

	onUploaded(files: ImageModel[]) {
		if (files != null) {
			files.forEach(f => this.canAdd && this.images.push(f));
			this.onChange.emit(this.images);
		}
	}

	onBeginUploading(e: any) {
		this.onBegin.emit(true);
	}

	remove(image: ImageModel) {
		const idx = this.images.indexOf(image);
		if (idx >= 0) {
			this.images.splice(idx, 1);
			this.onRemove.emit(image);
			this.onChange.emit(this.images);
		}
	}
}

export interface ImageModel {
	id: number;
	thumbnailUrl: string;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/components/sm-images-editor.component.ts